/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { Fragment, useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../../AuthProvider'
import { fectchQuoteToday, setSetting } from "../../../Components/action/common";
import moment from "moment";
import QuoteLoader from "../../../Components/SkeletonLoading/QuoteLoader";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { pushToSetting } from "../../../redux/slices/SettingSclice";
import { RitualIcon } from "../../../Components/LandingHeader/Feedback/icons/Icons";

const Greetings = () => {
    const {userProfile} = useContext(AuthContext);
    const [loader, setLoader] = useState(false);
    const [quotesList, setQuotesList] = useState([]);
    const {settings} = useSelector(state => state.settings);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        todayQuotes();
    }, [])

    const todayQuotes = async () => {
        let date = new Date(moment().startOf('date')).toISOString()
        try {
          setLoader(true)
          let response = await fectchQuoteToday({ "date": date })
          setQuotesList(response?.data?.responseData ?? [])
          setLoader(false)
        } catch ({ response }) {
            setLoader(false)
        }
    }

    const skipGreetings = async (e) => {
        e.preventDefault();
        const newSettings = { ...settings, 'ritualsOk': moment().startOf('date').toISOString() };
        dispatch(pushToSetting(newSettings));

        try {
          await setSetting({ "settings": newSettings })
          navigate(process.env.REACT_APP_ROOT);
        } catch ({ response }) { }
    }

    return (
        <div className='greetings-container flex flex-col gap-5'>
            <div className="self-stretch inline-flex justify-start items-center gap-2.5">
                <RitualIcon />
                <div className="flex-1 justify-center text-black/60 dark:text-white/60 text-2xl font-normal font-['RL_Madena'] dark-primary-color-60">Morning Ritual</div>
            </div>
            <div className="self-stretch inline-flex flex-col justify-center items-center gap-10 h-[100vh] mt-[60px] mb-[60px]">
                <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
                    <div className="self-stretch text-center justify-center dark-primary-color dark:darkmode-light-primary-color text-4xl font-normal font-['RL_Madena']">Good Morning, {userProfile?.given_name}</div>
                    <div className="self-stretch text-center justify-center dark-primary-color-20 text-4xl font-normal font-['RL_Madena']">Welcome to your daily morning ritual.</div>
                    <div className="self-stretch text-center justify-center dark-primary-color-60 text-base font-normal font-['Inter'] leading-normal">Let’s start with Today’s Quote</div>
                </div>
                <div className="self-center flex flex-col justify-start items-start gap-2.5">
                    {
                        loader === true ? <QuoteLoader /> :
                        quotesList?.map((quotes , idx) => {
                            return (
                                <Fragment key={idx}>
                                {
                                    moment(quotes?.date).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD') ? <><div className="self-stretch text-center justify-center dark-primary-color-20 text-6xl font-normal font-['RL_Madena'] italic">{quotes?.title}</div>
                                    <div className="self-stretch text-center justify-center dark-primary-color-60 text-base font-normal font-['Inter'] leading-normal">-{quotes?.author}</div></> : ""
                                }
                                </Fragment>
                            )
                        })
                    }
                </div>
            </div>
            <div className="self-stretch inline-flex justify-center items-center gap-2.5">
                <div className="flex justify-center items-center gap-2">
                    <Link to="/morning-rituals?step=gratitude" className="justify-center !text-white text-sm font-medium font-['Inter'] button primary dark-background-color !h-auto line-height-normal">
                        Start Ritual
                    </Link>
                </div>
                <div className="flex justify-center items-center gap-2">
                    <a href="#" onClick={skipGreetings} className="px-3.5 py-2.5 rounded-[50px] outline outline-1 outline-white/5 justify-center !text-neutral-400 text-sm font-medium font-['Inter'] bg-white dark:bg-black flex items-center gap-2 !leading-[15px]">
                        Skip
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Greetings